import React from 'react'
import { useCart } from 'lib/core/hooks'
import { Spinner } from 'lib/ui'
import { Container } from './styled'

interface Props {
  onEdit?: () => void
  isLoading: boolean
}

export const AddressCard = ({ onEdit, isLoading }: Props) => {
  const { cart } = useCart()

  const {
    city,
    company,
    countryCode,
    firstName,
    lastName,
    phoneNumber,
    postalCode,
    regionLabel,
    street
  } = cart?.data?.billingAddress ?? {}

  return (
    <Container isLoading={isLoading}>
      {isLoading ? (
        <Spinner />
      ) : (
        <div>
          <p>{firstName} {lastName}</p>
          {company && (
            <p>{company}</p>
          )}
          <p>{street}</p>
          <p>{city}, {regionLabel}, {postalCode}, {countryCode}</p>
          {phoneNumber && (
            <p>{phoneNumber}</p>
          )}

          {onEdit && (
            <button onClick={onEdit}>Edit</button>
          )}
        </div>
      )}
    </Container>
  )
}
